module.exports = "<tr>\n    <td class=\"text-center\"><strong>Total {{ price | currency:'USD':true}}</strong></td>\n</tr>\n<tr>\n    <td><a class=\"btn btn-success btn-block\" [class.disabled]=\"price === 0\" (click)=\"checkOutClicked()\">Checkout <i class=\"fa fa-angle-right\"></i></a></td>\n</tr>"


//////////////////
// WEBPACK FOOTER
// ./src/components/cart/cart-total.component.html
// module id = 52
// module chunks = 0 1